var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUmanAi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "400.000000pt",
    height: "400.000000pt",
    viewBox: "0 0 400.000000 400.000000",
    preserveAspectRatio: "xMidYMid meet",
    color: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,400.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1760 3985 c-435 -54 -826 -241 -1143 -545 -799 -765 -824 -2024 -57 -2823 765 -799 2024 -824 2823 -57 871 835 808 2242 -134 3000 -415 334 -963 490 -1489 425z m-38 -1747 c3 -488 4 -504 24 -548 50 -106 137 -131 289 -83 56 18 156 66 198 95 l27 19 0 510 0 509 240 0 240 0 0 -750 0 -750 -134 0 -134 0 -53 73 c-28 39 -53 73 -54 75 -1 1 -50 -22 -108 -53 -201 -107 -331 -145 -492 -145 -234 0 -378 79 -461 253 -62 132 -64 158 -64 758 l0 539 240 0 239 0 3 -502z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmanAi);
export default __webpack_public_path__ + "static/media/uman-ai.c9642088.svg";
export { ForwardRef as ReactComponent };